import React, { createContext, useState } from "react";
const AppContext = createContext({});

function ContextProvider({ children }) {
  const [customerDetails, setCustomerDetails] = useState({});
  const [mobile, setMobile] = useState("");
  const [sliderAmount, setSliderAmount] = useState(150);
  const [inviteFlag, setInviteFlag] = useState(false);

  return (
    <AppContext.Provider
      value={{
        customerDetails,
        setCustomerDetails,
        mobile,
        setMobile,
        sliderAmount,
        setSliderAmount,
        inviteFlag,
        setInviteFlag,
      }}
    >
      {children}
    </AppContext.Provider>
  );
}

export { ContextProvider, AppContext };
